import { application } from "./application"

import CookieConsentController from "./cookie_consent_controller"
application.register("cookie-consent", CookieConsentController)

import TurboDialogController from "./turbo_dialog_controller"
application.register("turbo-dialog", TurboDialogController)

import Users__PasswordController from "./users/password_controller"
application.register("users--password", Users__PasswordController)

import Notification from '@stimulus-components/notification'
application.register('notification', Notification)

import CollapseController from "./collapse_controller"
application.register("collapse", CollapseController)

import SubmenuController from "./submenu_controller"
application.register("submenu", SubmenuController)

import SliderController from "./slider_controller"
application.register("slider", SliderController)

import SearchFilterController from "./search_filter_controller"
application.register("search-filter", SearchFilterController)
